import { useAuthContext } from "BEDROCK/auth/auth-provider";

export const useMapboxProxy = () => {
  const { session } = useAuthContext();

  async function fetchMapboxImageViaProxy(mapboxUrl: string): Promise<string> {
    const token = session?.access_token;
    if (!token) {
      throw new Error("No Supabase auth token found");
    }

    const encodedUrl = encodeURIComponent(mapboxUrl);
    const project = process.env.REACT_APP_SUPABASE_PROJECT;

    const proxyUrl = `https://${project}.supabase.co/functions/v1/map-box-proxy?url=${encodedUrl}`;

    const response = await fetch(proxyUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch map image via proxy: ${response.statusText}`
      );
    }

    const blob = await response.blob();
    return await blobToBase64(blob);
  }

  return {
    fetchMapboxImageViaProxy,
  };
};

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
